import * as actionTypes from '../actions/actionTypes';

const initialState = {
  wizard_finished_status: false
};


const reducer = (state=initialState, action) => {
  switch (action.type) {

    case actionTypes.SET_WIZARD_FINISHED:
      return {
        ...state,
        wizard_finished_status: true,
      };

    case actionTypes.SET_WIZARD_UNFINISHED:
      return {
        ...state,
        wizard_finished_status: false,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/stats.js